import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationBuilderRoutingModule } from './organization-builder-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';
import { PlainFooterModule } from '../plain-footer/plain-footer.module';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { OrganizationBuilderComponent } from './organization-builder/organization-builder.component';
import { OrganizationBuilderFormComponent } from './organization-builder-form/organization-builder-form.component';

@NgModule({
  declarations: [OrganizationBuilderComponent, OrganizationBuilderFormComponent],
  imports: [
    CommonModule,
    OrganizationBuilderRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    PlainToolbarModule,
    PlainFooterModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
  ],
})
export class OrganizationBuilderModule {}
